<template>
    <b-row class="match-height weekly">
        <b-col cols="12">
            <b-row>
                <b-col class="col-12 col-md-3">
                    <b-row>
                        <b-col
                            v-show="!details"
                            class="col-12"
                        >
                            <card-analytic-total-page-views-weekly
                                v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly' )"
                                title="Compared to Previous Week"
                                :data-object="mainQuery"
                                :on-progress="mainQueryOnProgress"
                                :user-statistics="userStatistics"
                                :user-statistics-on-progress="userStatisticsOnProgress"
                                :user-statistics-previous-week="userStatisticsPreviousWeek"
                                :user-statistics-previous-week-on-progress="userStatisticsPreviousWeekOnProgress"
                                :pv-previous-week="graphPreviousWeek"
                                :pv-previous-week-on-progress="graphPreviousWeekOnProgress"
                            />
                            <card-analytic-total-authors
                                v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly-authors' )"
                                :data-object="mainQuery"
                                :on-progress="mainQueryOnProgress"
                            />
                            <card-analytic-total-breadcrumbs
                                v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly-breadcrumbs' )"
                                :data-object="mainQuery"
                                :on-progress="mainQueryOnProgress"
                            />
                            <card-analytic-total-sources
                                v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly-sources' )"
                                :data-object="mainQuery"
                                :on-progress="mainQueryOnProgress"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-12">
                            <page-filter :filters="getFilterObject()" />
                        </b-col>
                    </b-row>
                </b-col>
                <b-col
                    v-show="!details"
                    class="col-12 col-md-9"
                >
                    <b-row>
                        <b-col cols="12">
                            <apex-line-area-chart-weekly
                                v-if="!isMobile()"
                                :series1-name="seriesNamePreviewsWeek"
                                :series1="graphPreviousWeek"
                                :series2-name="seriesNameSelectedWeek"
                                :series2="mainQuery"
                                :avg-statistics="mainQuery"
                                :avg-statistics-on-progress="mainQueryOnProgress"
                                :on-progress="mainQueryOnProgress"
                                :skin-mode="this.skinMode"
                                :re-render="apexRender"
                            />
                            <b-card
                                v-if="isMobile()"
                            >
                                <card-analytics-avg-page-statistics-weekly
                                    :data-object="mainQuery"
                                    :on-progress="mainQueryOnProgress"
                                />
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <div class="navbar-container">
                                <b-tabs content-class="mt-1">
                                    <Tab
                                        v-for="(tab,i) in tabInfos"
                                        v-if="!tab.can || $can('read', tab.can)"
                                        :key="i"
                                        :active="$route.matched.some(({ name }) => name === `${getTabConstant}-${tab.static}`)"
                                        :title="tab.name"
                                        @handleClick="handleTabClick(tab.static)"
                                    />
                                </b-tabs>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <page-view-table-weekly
                                v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly' )"
                                :page-views="mainQuery"
                                :on-progress="mainQueryOnProgress"
                                :by-content-filter="byContentFilter"
                                :details-page-url="detailsPageUrl"
                                @openDetails="openDetails"
                            />
                            <authors-table
                                v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly-authors' )"
                                :table-object="mainQuery"
                                :on-progress="mainQueryOnProgress"
                            />
                            <breadcrumbs-table
                                v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly-breadcrumbs' )"
                                :table-object="mainQuery"
                                :on-progress="mainQueryOnProgress"
                            />
                            <sources-table
                                v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly-sources' )"
                                :table-object="mainQuery"
                                :on-progress="mainQueryOnProgress"
                            />
                        </b-col>
                    </b-row>
                </b-col>
                <b-col
                    v-show="details"
                    class="col-12 col-md-9"
                >
                    <news-details
                        :details="details"
                        :on-progress="mainQueryOnProgress"
                        @closeDetails="closeDetails"
                    />
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import {
    BTabs,
    BCard,
    BRow,
    BCol,
} from 'bootstrap-vue'

import querystring from 'querystring'
import usAppConfig from '@core/app-config/useAppConfig'
import ApexLineAreaChartWeekly from '@/views/charts/apex/ApexLineAreaChartWeekly.vue'
import { executeQuery, resetQueries, resetQuery } from '@/coreApi/coreApiDataset'
import coreApiDataIndex from '@/coreApi/coreApiDataIndex'
import { getCoreApiData, getCoreApiDataOnProgress } from '@/coreApi/coreApi'
import PageFilter from '@/views/components/filters/PageFilter.vue'
import { coreApiPageWeekFilterObject } from '@/coreApi/filters/coreApiPageWeekFilter'
import CardAnalyticTotalPageViewsWeekly from '@/views/card/card-analytic/CardAnalyticTotalPageViewsWeekly.vue'
import CardAnalyticTotalAuthors from '@/views/card/card-analytic/CardAnalyticTotalAuthors.vue'
import CardAnalyticTotalBreadcrumbs from '@/views/card/card-analytic/CardAnalyticTotalBreadcrumbs.vue'
import CardAnalyticTotalSources from '@/views/card/card-analytic/CardAnalyticTotalSources.vue'
import PageViewTableWeekly from '@/views/components/tables/PageViewTableWeekly.vue'
import AuthorsTable from '@/views/components/tables/AuthorsTable.vue'
import BreadcrumbsTable from '@/views/components/tables/BreadcrumbsTable.vue'
import SourcesTable from '@/views/components/tables/SourcesTable.vue'
import Tab from '@/views/components/tabs/tab.vue'
import CardAnalyticsAvgPageStatisticsWeekly from '@/views/card/card-analytic/CardAnalyticsAvgPageStatisticsWeekly.vue'
import { getProjectCoreProjectId, getProjectFilterObject } from '@/coreApi/filters/coreApiFilterHelper'
import NewsDetails from '@/views/components/details/NewsDetails.vue'
import { coreApiDetailFilterObject } from '@/coreApi/filters/coreApiDetailFilter'

// eslint-disable-next-line no-unused-vars,import/no-extraneous-dependencies
const moment = require('moment')

export default {
    components: {
        NewsDetails,
        CardAnalyticsAvgPageStatisticsWeekly,
        CardAnalyticTotalPageViewsWeekly,
        CardAnalyticTotalAuthors,
        CardAnalyticTotalSources,
        CardAnalyticTotalBreadcrumbs,
        PageViewTableWeekly,
        AuthorsTable,
        BreadcrumbsTable,
        SourcesTable,
        BTabs,
        BCard,
        BRow,
        BCol,
        ApexLineAreaChartWeekly,
        PageFilter,
        Tab,
    },
    data() {
        return {
            details: null,
            detailsPageUrl: null,
            byContentFilter: true,
            seriesNamePreviewsWeek: 'Previous Week',
            seriesNameSelectedWeek: 'Current Week',
            longCacheTime: 7257960,
            shortCacheTime: 3600,
            tabInfos: [
                {
                    name: 'Pages',
                    static: 'weekly',
                    can: null,
                },
                {
                    name: 'Author',
                    static: 'weekly-authors',
                    can: 'AuthorTab',
                },
                {
                    name: 'Categories',
                    static: 'weekly-breadcrumbs',
                    can: null,
                },
                {
                    name: 'Sources',
                    static: 'weekly-sources',
                    can: null,
                },
            ],
            lastQueryHash: null,
            apexRender: 0,
        }
    },
    computed: {
        getTabConstant() {
            return 'project-frontend-dashboard'
        },
    },
    watch: {
        $route() {
            this.initQueries()
            this.intiDetails()
        },
    },
    created() {
        this.initQueries()
        this.intiDetails()
    },
    methods: {
        handleTabClick(name) {
            if (this.$route.name !== `${this.getTabConstant}-${name}`) {
                this.$router.push({ name: `${this.getTabConstant}-${name}` })
            }
        },
        isMobile() {
            return window.innerWidth < 768
        },
        getCurrentHashList() {
            let currentHashList = {}
            if (this.$route.hash) {
                currentHashList = querystring.parse(this.$route.hash.slice(1))
            }
            return currentHashList
        },
        initQueries() {
            const projectFilterObject = getProjectFilterObject()
            const pageFilter = projectFilterObject.getFilterQueryObject()
            const pageTimeFilter = coreApiPageWeekFilterObject.getFilterQueryObject()
            const projectId = getProjectCoreProjectId()

            const queryHash = JSON.stringify(pageFilter) + JSON.stringify(pageTimeFilter) + projectId + this.$route.name
            if (!this.lastQueryHash || this.lastQueryHash !== queryHash) {
                this.lastQueryHash = queryHash
                if (this.$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly')) {
                    this.queryPageView(projectId, pageFilter, pageTimeFilter)
                } else if (this.$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly-authors')) {
                    this.queryAuthor(projectId, pageFilter, pageTimeFilter)
                } else if (this.$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly-breadcrumbs')) {
                    this.queryBreadcrumb(projectId, pageFilter, pageTimeFilter)
                } else if (this.$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly-sources')) {
                    this.querySource(projectId, pageFilter, pageTimeFilter)
                }
            }
        },
        getFilterObject() {
            const projectFilterObject = getProjectFilterObject()

            const filterList = projectFilterObject.getFilterList()

            const isPageView = this.$route.matched.some(({ name }) => name === 'project-frontend-dashboard-weekly')

            return filterList.filter(obj => isPageView || !['kw', 'kwn', 'srch'].includes(obj.key))
        },
        queryPageView(projectId, pageFilter, pageTimeFilter) {
            if (['bl8372p22-kd', 'bl8372p22-tv', 'bl8372p22-hs', 'bl8372p22-ms', 'bl8372p22-cns', 'bl8372p22-psts', 'bl8372p22-gvs', 'bl8372p22-rd', 'bl2ok5med65lk2-muo'].includes(projectId)) {
                this.byContentFilter = false
            } else {
                this.byContentFilter = true
            }

            let projectIdBase = projectId
            if (projectIdBase.indexOf('-') > -1) {
                projectIdBase = projectIdBase.slice(0, projectIdBase.indexOf('-'))
            }

            if (projectId === 'bl8372p22-hs') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({ key: 'projectId', value: 'bl1767ftdlk224' })
                pageFilter.push({ key: 'page_domains', value: 'secim.hurriyet.com.tr' })
            } else if (projectId === 'bl8372p22-ms') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({ key: 'projectId', value: 'bl2ok5med65lk2' })
                pageFilter.push({ key: 'page_domains', value: 'secim.milliyet.com.tr' })
            } else if (projectId === 'bl8372p22-cns') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({ key: 'projectId', value: 'bl8372p22-cn' })
                pageFilter.push({ key: 'page_domains', value: 'secim.cnnturk.com' })
            } else if (projectId === 'bl8372p22-psts') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({ key: 'projectId', value: 'bl8372p22-ps' })
                pageFilter.push({ key: 'page_domains', value: 'secim.posta.com.tr' })
            } else if (projectId === 'bl8372p22-gvs') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({ key: 'projectId', value: 'bl8372p22-gv' })
                pageFilter.push({ key: 'page_domains', value: 'secim.gazetevatan.com' })
            } else if (projectId === 'bl1767ftdlk224-ho') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({ key: 'projectId', value: 'bl1767ftdlk224' })
                pageFilter.push({ key: 'page_domains', value: 'www.hurriyet.com.tr' })
            } else if (projectId === 'bl1767ftdlk224-hbo') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({ key: 'projectId', value: 'bl1767ftdlk224' })
                pageFilter.push({ key: 'page_domains', value: 'bigpara.hurriyet.com.tr,mbigpara.hurriyet.com.tr' })
            } else if (projectId === 'bl2ok5med65lk2-mo') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'www.milliyet.com.tr,m.milliyet.com.tr',
                })
            } else if (projectId === 'bl2ok5med65lk2-muo') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'uzmanpara.milliyet.com.tr,uzmanparam.milliyet.com.tr',
                })
            } else {
                pageFilter.push({ key: 'projectId', value: projectId })
            }

            const startDate = moment()
                .subtract(pageTimeFilter.skip, 'weeks')
            const startDatePreview = moment()
                .subtract(pageTimeFilter.skip + 1, 'weeks')
            const startDateString = startDate.weekday(1).format('YYYY-MM-DD')
            const startDatePreviewString = startDatePreview.weekday(1).format('YYYY-MM-DD')
            const endDate = startDate.add(pageTimeFilter.take - 1, 'weeks')
            const endDatePreview = startDatePreview.add(pageTimeFilter.take - 1, 'weeks')
            const endDateString = endDate.weekday(6).add(1, 'days').format('YYYY-MM-DD')
            const endDatePreviewString = endDatePreview.weekday(6).add(1, 'days').format('YYYY-MM-DD')

            let timeout = this.shortCacheTime
            if (pageTimeFilter.skip > 0) {
                timeout = this.longCacheTime
                if (
                    startDate.week() === moment()
                        .subtract(1, 'weeks')
                        .week()
                    // eslint-disable-next-line radix
                    && parseInt(moment()
                        .weekday()) === 1
                    // eslint-disable-next-line radix
                    && parseInt(moment()
                        .format('HH')) < 3
                ) {
                    timeout = 600
                }
            }

            // d1: mainQuery..
            // d4: graphPreviousMonth..
            // d6: userStatistics..
            // d7: userStatisticsPreviousMonth..

            executeQuery(
                coreApiDataIndex.d1,
                {
                    startDate: startDateString,
                    endDate: endDateString,
                    timeout,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyPageViewStatistics',
                            options: [
                                {
                                    alias: 'weeklyPageViewStatistics',
                                    return_id: 'statistics',
                                    offset: 0,
                                    limit: 1,
                                },
                                {
                                    alias: 'pageView',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulativePageView',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyPageViewDetails',
                            options: [
                                {
                                    alias: 'weeklyPageViewDetails',
                                    return_id: 'pageView',
                                    offset: 0,
                                    limit: 200,
                                },
                                {
                                    alias: 'pageView',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulativePageView',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyPageViewGraphPVCount',
                            options: [
                                {
                                    alias: 'weeklyPageViewGraphPVCount',
                                    return_id: 'graph',
                                    filter_values: pageFilter,
                                    offset: 0,
                                    limit: 3000,
                                },
                                {
                                    alias: 'pageView',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulativePageView',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                    ],
                },
            )

            const previewsWeekIndicator = { ...pageTimeFilter }
            previewsWeekIndicator.skip += 1
            // if (pageTimeFilter.skip > 0) {
            this.seriesNamePreviewsWeek = ` Week ${moment()
                .subtract(previewsWeekIndicator.skip, 'weeks')
                .format('ww')}`
            this.seriesNameSelectedWeek = ` Week ${moment()
                .subtract(previewsWeekIndicator.skip - 1, 'weeks')
                .format('ww')}`
            // }
            let previewsWeekTimeout = this.longCacheTime
            // eslint-disable-next-line radix
            if (parseInt(moment()
                .format('HH')) < 3) {
                previewsWeekTimeout = 600
            }
            executeQuery(
                coreApiDataIndex.d4,
                {
                    startDate: startDatePreviewString,
                    endDate: endDatePreviewString,
                    timeout: previewsWeekTimeout,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyPageViewStatistics',
                            options: [
                                {
                                    alias: 'weeklyPageViewStatistics',
                                    return_id: 'statistics',
                                    offset: 0,
                                    limit: 1,
                                },
                                {
                                    alias: 'pageView',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulativePageView',
                                    filter_date_indicator: previewsWeekIndicator,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyPageViewGraphPVCount',
                            options: [
                                {
                                    alias: 'weeklyPageViewGraphPVCount',
                                    return_id: 'previousWeekGraph',
                                    offset: 0,
                                    limit: 3000,
                                },
                                {
                                    alias: 'pageView',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulativePageView',
                                    filter_date_indicator: previewsWeekIndicator,
                                },
                            ],
                        },
                    ],
                },
            )

            // Check if the User Statistics Data is available
            // for applied filters and call or cancel the query accordingly
            // Validation Starts

            let userStatisticsValid = true

            const validUserFilters = [
                'projectId',
                'origin_referer_domain',
                'source',
                'device',
                'user_types',
            ]

            pageFilter.forEach(pageFilterItem => {
                if (!validUserFilters.includes(pageFilterItem.key)) {
                    userStatisticsValid = false
                }
            })

            if (userStatisticsValid) {
                // User Statistics Selected Week
                executeQuery(
                    coreApiDataIndex.d6,
                    {
                        startDate: startDateString,
                        endDate: endDateString,
                        timeout,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'userStatisticsWeekly',
                                options: [
                                    {
                                        alias: 'userStatisticsWeekly',
                                        return_id: 'd6',
                                        offset: 0,
                                        limit: 1,
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'userWeekly',
                                        filter_date_indicator: pageTimeFilter,
                                    },
                                ],
                            },
                        ],
                    },
                )
                // User Statistics Previous Week
                executeQuery(
                    coreApiDataIndex.d7,
                    {
                        startDate: startDatePreviewString,
                        endDate: endDatePreviewString,
                        timeout: previewsWeekTimeout,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'userStatisticsWeekly',
                                options: [
                                    {
                                        alias: 'userStatisticsWeekly',
                                        return_id: 'previousWeekUserStatistics',
                                        offset: 0,
                                        limit: 1,
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'userWeekly',
                                        filter_date_indicator: previewsWeekIndicator,
                                    },
                                ],
                            },
                        ],
                        version: 1,
                    },
                )
            } else {
                resetQuery(coreApiDataIndex.d6)
                resetQuery(coreApiDataIndex.d7)
            }
            // Validation Ends
        },
        queryAuthor(projectId, pageFilter, pageTimeFilter) {
            let projectIdBase = projectId
            if (projectIdBase.indexOf('-') > -1) {
                projectIdBase = projectIdBase.slice(0, projectIdBase.indexOf('-'))
            }
            pageFilter.push({
                key: 'projectId',
                value: projectId
            })

            const startDate = moment()
                .subtract(pageTimeFilter.skip, 'weeks')
            const startDatePreview = moment()
                .subtract(pageTimeFilter.skip + 1, 'weeks')
            const startDateString = startDate.weekday(1)
                .format('YYYY-MM-DD')
            const startDatePreviewString = startDatePreview.weekday(1)
                .format('YYYY-MM-DD')
            const endDate = startDate.add(pageTimeFilter.take - 1, 'weeks')
            const endDatePreview = startDatePreview.add(pageTimeFilter.take - 1, 'weeks')
            const endDateString = endDate.weekday(6)
                .add(1, 'days')
                .format('YYYY-MM-DD')
            const endDatePreviewString = endDatePreview.weekday(6)
                .add(1, 'days')
                .format('YYYY-MM-DD')

            let timeout = this.shortCacheTime
            if (pageTimeFilter.skip > 0) {
                timeout = this.longCacheTime
                if (
                    startDate.week() === moment()
                        .subtract(1, 'weeks')
                        .week()
                    // eslint-disable-next-line radix
                    && parseInt(moment()
                        .weekday()) === 1
                    // eslint-disable-next-line radix
                    && parseInt(moment()
                        .format('HH')) < 3
                ) {
                    timeout = 600
                }
            }

            executeQuery(
                coreApiDataIndex.d1,
                {
                    startDate: startDateString,
                    endDate: endDateString,
                    timeout,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyAuthorStatistics',
                            options: [
                                {
                                    alias: 'weeklyAuthorStatistics',
                                    return_id: 'statistics',
                                    offset: 0,
                                    limit: 1,
                                },
                                {
                                    alias: 'onDemand',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulative',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyAuthorDetails',
                            options: [
                                {
                                    alias: 'weeklyAuthorDetails',
                                    return_id: 'tableData',
                                    offset: 0,
                                    limit: 200,
                                },
                                {
                                    alias: 'onDemand',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulative',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyAuthorGraphPVCount',
                            options: [
                                {
                                    alias: 'weeklyAuthorGraphPVCount',
                                    return_id: 'graph',
                                    filter_values: pageFilter,
                                    offset: 0,
                                    limit: 3000,
                                },
                                {
                                    alias: 'onDemand',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulative',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                    ],
                },
            )
            if (pageTimeFilter.take !== 1) {
                resetQuery(coreApiDataIndex.d6)
            }

            if (!this.isMobile()) {
                const previewsWeekIndicator = { ...pageTimeFilter }
                previewsWeekIndicator.skip += 1
                // if (pageTimeFilter.skip > 0) {
                this.seriesNamePreviewsWeek = ` Week ${moment()
                    .subtract(previewsWeekIndicator.skip, 'weeks')
                    .format('ww')}`
                this.seriesNameSelectedWeek = ` Week ${moment()
                    .subtract(previewsWeekIndicator.skip - 1, 'weeks')
                    .format('ww')}`
                // }
                let previewsWeekTimeout = this.longCacheTime
                // eslint-disable-next-line radix
                if (parseInt(moment()
                    .format('HH')) < 3) {
                    previewsWeekTimeout = 600
                }

                executeQuery(
                    coreApiDataIndex.d4,
                    {
                        startDate: startDatePreviewString,
                        endDate: endDatePreviewString,
                        timeout: previewsWeekTimeout,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'weeklyAuthorGraphPVCount',
                                options: [
                                    {
                                        alias: 'weeklyAuthorGraphPVCount',
                                        return_id: 'PreviousWeek',
                                    },
                                    {
                                        alias: 'onDemand',
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'cumulative',
                                        filter_date_indicator: previewsWeekIndicator,
                                    },
                                ],
                            },
                            {
                                project_id: projectIdBase,
                                alias: 'weeklyAuthorStatistics',
                                options: [
                                    {
                                        alias: 'weeklyAuthorStatistics',
                                        return_id: 'statistics',
                                        offset: 0,
                                        limit: 1,
                                    },
                                    {
                                        alias: 'onDemand',
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'cumulative',
                                        filter_date_indicator: previewsWeekIndicator,
                                    },
                                ],
                            },
                        ],
                        version: 1,
                    },
                )
            }
        },
        queryBreadcrumb(projectId, pageFilter, pageTimeFilter) {
            let projectIdBase = projectId
            if (projectIdBase.indexOf('-') > -1) {
                projectIdBase = projectIdBase.slice(0, projectIdBase.indexOf('-'))
            }
            pageFilter.push({
                key: 'projectId',
                value: projectId
            })

            const startDate = moment()
                .subtract(pageTimeFilter.skip, 'weeks')
            const startDatePreview = moment()
                .subtract(pageTimeFilter.skip + 1, 'weeks')
            const startDateString = startDate.weekday(1)
                .format('YYYY-MM-DD')
            const startDatePreviewString = startDatePreview.weekday(1)
                .format('YYYY-MM-DD')
            const endDate = startDate.add(pageTimeFilter.take - 1, 'weeks')
            const endDatePreview = startDatePreview.add(pageTimeFilter.take - 1, 'weeks')
            const endDateString = endDate.weekday(6)
                .add(1, 'days')
                .format('YYYY-MM-DD')
            const endDatePreviewString = endDatePreview.weekday(6)
                .add(1, 'days')
                .format('YYYY-MM-DD')

            let timeout = this.shortCacheTime
            if (pageTimeFilter.skip > 0) {
                timeout = this.longCacheTime
                if (
                    startDate.week() === moment()
                        .subtract(1, 'weeks')
                        .week()
                    // eslint-disable-next-line radix
                    && parseInt(moment()
                        .weekday()) === 1
                    // eslint-disable-next-line radix
                    && parseInt(moment()
                        .format('HH')) < 3
                ) {
                    timeout = 600
                }
            }

            executeQuery(
                coreApiDataIndex.d1,
                {
                    startDate: startDateString,
                    endDate: endDateString,
                    timeout,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyBreadcrumbStatistics',
                            options: [
                                {
                                    alias: 'weeklyBreadcrumbStatistics',
                                    return_id: 'statistics',
                                    offset: 0,
                                    limit: 1,
                                },
                                {
                                    alias: 'onDemand',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulative',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyBreadcrumbDetails',
                            options: [
                                {
                                    alias: 'weeklyBreadcrumbDetails',
                                    return_id: 'tableData',
                                    offset: 0,
                                    limit: 200,
                                },
                                {
                                    alias: 'onDemand',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulative',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'weeklyBreadcrumbGraphPVCount',
                            options: [
                                {
                                    alias: 'weeklyBreadcrumbGraphPVCount',
                                    return_id: 'graph',
                                    filter_values: pageFilter,
                                    offset: 0,
                                    limit: 3000,
                                },
                                {
                                    alias: 'onDemand',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulative',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                    ],
                },
            )
            if (pageTimeFilter.take !== 1) {
                resetQuery(coreApiDataIndex.d6)
            }
            if (!this.isMobile()) {
                const previewsWeekIndicator = { ...pageTimeFilter }
                previewsWeekIndicator.skip += 1
                // if (pageTimeFilter.skip > 0) {
                this.seriesNamePreviewsWeek = ` Week ${moment()
                    .subtract(previewsWeekIndicator.skip, 'weeks')
                    .format('ww')}`
                this.seriesNameSelectedWeek = ` Week ${moment()
                    .subtract(previewsWeekIndicator.skip - 1, 'weeks')
                    .format('ww')}`
                // }
                let previewsWeekTimeout = this.longCacheTime
                // eslint-disable-next-line radix
                if (parseInt(moment()
                    .format('HH')) < 1) {
                    previewsWeekTimeout = 600
                }
                // Diamond Daily Graph Page View Count Weekly jf5b38784b38e
                executeQuery(
                    coreApiDataIndex.d4,
                    {
                        startDate: startDatePreviewString,
                        endDate: endDatePreviewString,
                        timeout: previewsWeekTimeout,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'weeklyBreadcrumbGraphPVCount',
                                options: [
                                    {
                                        alias: 'weeklyBreadcrumbGraphPVCount',
                                        return_id: 'previousWeek',
                                    },
                                    {
                                        alias: 'onDemand',
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'cumulative',
                                        filter_date_indicator: previewsWeekIndicator,
                                    },
                                ],
                            },
                            {
                                project_id: projectIdBase,
                                alias: 'weeklyBreadcrumbStatistics',
                                options: [
                                    {
                                        alias: 'weeklyBreadcrumbStatistics',
                                        return_id: 'statistics',
                                        offset: 0,
                                        limit: 1,
                                    },
                                    {
                                        alias: 'onDemand',
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'cumulative',
                                        filter_date_indicator: previewsWeekIndicator,
                                    },
                                ],
                            },
                        ],
                        version: 1,
                    },
                )
            }
        },
        querySource(projectId, pageFilter, pageTimeFilter) {
            let projectIdBase = projectId
            if (projectIdBase.indexOf('-') > -1) {
                projectIdBase = projectIdBase.slice(0, projectIdBase.indexOf('-'))
            }
            pageFilter.push({
                key: 'projectId',
                value: projectId
            })

            const startDate = moment()
                .subtract(pageTimeFilter.skip, 'weeks')
            const startDatePreview = moment()
                .subtract(pageTimeFilter.skip + 1, 'weeks')
            const startDateString = startDate.weekday(1)
                .format('YYYY-MM-DD')
            const startDatePreviewString = startDatePreview.weekday(1)
                .format('YYYY-MM-DD')
            const endDate = startDate.add(pageTimeFilter.take - 1, 'weeks')
            const endDatePreview = startDatePreview.add(pageTimeFilter.take - 1, 'weeks')
            const endDateString = endDate.weekday(6)
                .add(1, 'days')
                .format('YYYY-MM-DD')
            const endDatePreviewString = endDatePreview.weekday(6)
                .add(1, 'days')
                .format('YYYY-MM-DD')

            let timeout = this.shortCacheTime
            if (pageTimeFilter.skip > 0) {
                timeout = this.longCacheTime
                if (
                    startDate.week() === moment()
                        .subtract(1, 'weeks')
                        .week()
                    // eslint-disable-next-line radix
                    && parseInt(moment()
                        .weekday()) === 1
                    // eslint-disable-next-line radix
                    && parseInt(moment()
                        .format('HH')) < 3
                ) {
                    timeout = 600
                }
            }

            executeQuery(
                coreApiDataIndex.d1,
                {
                    startDate: startDateString,
                    endDate: endDateString,
                    timeout,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'weeklySourceStatistics',
                            options: [
                                {
                                    alias: 'weeklySourceStatistics',
                                    return_id: 'statistics',
                                    offset: 0,
                                    limit: 1,
                                },
                                {
                                    alias: 'onDemand',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulative',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'weeklySourceDetails',
                            options: [
                                {
                                    alias: 'weeklySourceDetails',
                                    return_id: 'tableData',
                                    offset: 0,
                                    limit: 200,
                                },
                                {
                                    alias: 'onDemand',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulative',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'weeklySourceGraphPVCount',
                            options: [
                                {
                                    alias: 'weeklySourceGraphPVCount',
                                    return_id: 'graph',
                                    filter_values: pageFilter,
                                    offset: 0,
                                    limit: 3000,
                                },
                                {
                                    alias: 'onDemand',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulative',
                                    filter_date_indicator: pageTimeFilter,
                                },
                            ],
                        },
                    ],
                },
            )
            if (pageTimeFilter.take !== 1) {
                resetQuery(coreApiDataIndex.d6)
            }
            if (!this.isMobile()) {
                const previewsWeekIndicator = { ...pageTimeFilter }
                previewsWeekIndicator.skip += 1
                // if (pageTimeFilter.skip > 0) {
                this.seriesNamePreviewsWeek = ` Week ${moment()
                    .subtract(previewsWeekIndicator.skip, 'weeks')
                    .format('ww')}`
                this.seriesNameSelectedWeek = ` Week ${moment()
                    .subtract(previewsWeekIndicator.skip - 1, 'weeks')
                    .format('ww')}`
                // }
                let previewsWeekTimeout = this.longCacheTime
                // eslint-disable-next-line radix
                if (parseInt(moment()
                    .format('HH')) < 1) {
                    previewsWeekTimeout = 600
                }

                executeQuery(
                    coreApiDataIndex.d4,
                    {
                        startDate: startDatePreviewString,
                        endDate: endDatePreviewString,
                        timeout: previewsWeekTimeout,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'weeklySourceGraphPVCount',
                                options: [
                                    {
                                        alias: 'weeklySourceGraphPVCount',
                                        return_id: 'previousWeek',
                                    },
                                    {
                                        alias: 'onDemand',
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'cumulative',
                                        filter_date_indicator: previewsWeekIndicator,
                                    },
                                ],
                            },
                            {
                                project_id: projectIdBase,
                                alias: 'weeklySourceStatistics',
                                options: [
                                    {
                                        alias: 'weeklySourceStatistics',
                                        return_id: 'statistics',
                                        offset: 0,
                                        limit: 1,
                                    },
                                    {
                                        alias: 'onDemand',
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'cumulative',
                                        filter_date_indicator: previewsWeekIndicator,
                                    },
                                ],
                            },
                        ],
                        version: 1,
                    },
                )
            }
        },
        intiDetails() {
            const projectFilterObject = getProjectFilterObject()
            const detailsObject = projectFilterObject.getFilterDetails()
            if (detailsObject) {
                if (
                    !this.details
                    && detailsObject.pageUrl
                ) {
                    this.detailsPageUrl = detailsObject.pageUrl
                }
            } else {
                this.closeDetails()
            }
        },
        openDetails(obj) {
            if (obj.details && obj.details.pageUrl) {
                const filters = { details: { pageUrl: obj.details.pageUrl } }
                const newPath = coreApiDetailFilterObject.getFilterUrl(filters)
                if (newPath !== this.$route.fullPath) {
                    this.$router.push(newPath)
                }
                this.detailsPageUrl = obj.details.pageUrl
            } else {
                this.closeDetails()
            }
            this.details = obj.details
        },
        closeDetails() {
            const filters = { details: null }
            const newPath = coreApiDetailFilterObject.getFilterUrl(filters)
            if (newPath !== this.$route.fullPath) {
                this.$router.push(newPath)
            }
            this.detailsPageUrl = null
            this.details = null
            this.apexRender += 1
        },
    },
    setup() {
        return {
            mainQuery: getCoreApiData(coreApiDataIndex.d1),
            mainQueryOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d1),
            graphPreviousWeek: getCoreApiData(coreApiDataIndex.d4),
            graphPreviousWeekOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d4),
            userStatistics: getCoreApiData(coreApiDataIndex.d6),
            userStatisticsOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d6),
            userStatisticsPreviousWeek: getCoreApiData(coreApiDataIndex.d7),
            userStatisticsPreviousWeekOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d7),
            skinMode: usAppConfig().skin,
        }
    },
    beforeRouteLeave(to, from, next) {
        resetQueries()
        next()
    },
}

</script>

<style>

</style>
